import React from "react"
import classNames from "classnames"
import {useTranslation} from "react-i18next"

// HOCs
import withRecordData, {WithRecordDataProps} from "../../hoc/withRecordData"

// Components
import DataParameter from "../DataParameter"

// Styles
import useStyles from "./styles"

/**
 * @param props
 */
function GeneralInfoSection(props: WithRecordDataProps) {
    const styles = useStyles();
    const [t] = useTranslation("common");
    const {
        metaData: {
            duration,
            sex,
            age,
            deviceId,
        },
        patientInfo: {
            id,
            firstName,
            surName
        }
    } = props;

    return (
        <div>
            <DataParameter
                value={id}
                name="ID"
                className={classNames(styles.parameter, styles.parameter__space)}
            />
            <DataParameter
                value={surName}
                name={t("records.surname")}
                className={classNames(styles.parameter, styles.parameter__space)}
            />
            <DataParameter
                value={firstName}
                name={t("records.name")}
                className={classNames(styles.parameter, styles.parameter__space)}
            />
            <DataParameter
                value={sex ? t(`records.${sex}`, {defaultValue: sex}) as string : undefined}
                name={t("records.sex")}
                className={classNames(styles.parameter, styles.parameter__space)}
            />
            <DataParameter
                value={age}
                name={t("records.age")}
                className={classNames(styles.parameter, styles.parameter__space)}
            />
            <DataParameter
                value="10.2s"
                name={t("records.duration")}
                className={classNames(styles.parameter, styles.parameter__space)}
            />
            <DataParameter
                value={deviceId}
                name={t("records.deviceId")}
                className={classNames(styles.parameter, styles.parameter__space)}
            />
        </div>
    )
}

export default withRecordData(GeneralInfoSection)
